// API del configurador: tasks de MaterializeProcess (área `materialize`) por el patrón RPC de
// Sherpa → POST {baseUrl}{ts}/materialize/<bloc>/task con { requestHeader, requestContent:{jsonData} }.
// Respuesta { ok, data } | { ok:false, error } (los errores de negocio llegan con HTTP 200).
import axios from 'axios';
import { getRuntimeConfig } from '@vem/config/runtimeConfig.js';

/** Ruta del nodo de menú que autoriza las tasks (frame_menu_extra_endpoint). */
const MENU_PATH = '/configuration/materialize-management/materialize-tool';

const client = axios.create({ timeout: 120000, headers: { 'Content-Type': 'application/json' } });

client.interceptors.request.use((config) => {
  const cfg = getRuntimeConfig();
  config.baseURL = cfg.baseUrl.endsWith('/') ? cfg.baseUrl : cfg.baseUrl + '/';
  if (cfg.token) {
    config.headers.Authorization = cfg.rawToken || /^bearer\s/i.test(cfg.token) ? cfg.token : `bearer ${cfg.token}`;
  }
  return config;
});

/** es_es → es_ES (formato de los textos i18n de Sherpa). */
function sherpaLang(lang) {
  const [l, c] = String(lang || 'es_es').split(/[_-]/);
  return `${l.toLowerCase()}_${(c || l).toUpperCase()}`;
}

function header() {
  const cfg = getRuntimeConfig();
  let origin = '';
  try { origin = new URL(cfg.baseUrl).origin; } catch { /* baseUrl relativa */ }
  return {
    lang: sherpaLang(cfg.lang),
    referer: `${origin}${MENU_PATH}`,
    externalReferer: `${origin}/login`,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    platform: typeof navigator !== 'undefined' ? navigator.platform : '',
  };
}

/** Error con el mensaje del backend ({ok:false,error}) o del transporte. */
export class ApiError extends Error {}

async function task(bloc, jsonData = null) {
  let res;
  try {
    res = await client.post(`${Date.now()}/materialize/${bloc}/task`, {
      requestHeader: header(),
      requestContent: { jsonData },
    });
  } catch (e) {
    const st = e?.response?.status;
    throw new ApiError(st === 401 ? 'Sin autorización (token caducado o usuario sin rol administrador)' : (e.message || 'Error de red'));
  }
  const body = res.data;
  if (!body || typeof body !== 'object' || !('ok' in body)) throw new ApiError('Respuesta inesperada del servidor');
  if (!body.ok) throw new ApiError(body.error || 'Error');
  return body.data;
}

export const listEntities = () => task('entities');
export const listForms = () => task('forms');
export const listDefs = () => task('deflist');
export const getDef = (id) => task('defget', { id });
export const saveDef = (dto) => task('defsave', dto);
export const deleteDef = (id) => task('defdelete', { id });
export const checkDef = (id) => task('defcheck', { id });
export const simulateDef = (id, limit = 50) => task('simulate', { id, limit });
export const runDef = (id) => task('run', { id });
export const lineage = (id, state = null, limit = 200) => task('lineage', { id, state, limit });
